import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';
import { HcToastOptions, HcToasterService } from '@healthcatalyst/cashmere';

export interface SourceElement {
    'sourceID': number,
    'name': string,
    'item': string,
    'typeID': number,
    'statusID': number,
    'revisionDate': string
}

@Injectable()
export class SourceService {
    sourceList: BehaviorSubject<SourceElement[] | null> = new BehaviorSubject<SourceElement[] | null>(null);
    loadFailed = false;

    constructor(private http: HttpClient, private oktaService: OktaService, private toasterService: HcToasterService) { };

    get sourceListUpdated(): Observable<SourceElement[] | null> {
        return this.sourceList.asObservable();
    }

    refresh() {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/sources', options)
            .subscribe({
                next: data => {
                    this.sourceList.next(data);
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.sourceList.next(null);
                    console.log(msg);
                }
            });
    }

    detail(sourceID: number): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.get<any>(environment.azure.url + '/admin.sources/' + sourceID, options);
    }

    add(target: SourceElement) {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.sources.add', target, options);
    }

    update(target: SourceElement) {
        // Update target in databases
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.sources.update', target, options);
    }

    remove(target: SourceElement) {
        // Remove target from database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        const postSub = this.http.post<any>(environment.azure.url + '/admin.sources.remove',
            {
                statusID: target.statusID
            },
            options
        ).subscribe({
            next: () => {
                this.refresh();
                const options: HcToastOptions = {
                    header: 'Source Removed',
                    body: target.name + " successfully removed.",
                    type: 'success',
                    position: 'bottom-right'
                };
                this.toasterService.addToast(options);
                postSub.unsubscribe();
            },
            error: msg => {
                const options: HcToastOptions = {
                    header: 'Remove Failed',
                    body: "Unable to remove source. Try again later.",
                    type: 'alert',
                    position: 'bottom-right'
                };
                this.toasterService.addToast(options);
                console.log(msg);
                postSub.unsubscribe();
            }
        });
    }
}